module.exports = __webpack_public_path__ + "img/icon6.f0a4f4b8.png";